import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
export const CurrentClaimCornSchema = ClaimV2CornSchema;
